"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _containers = require("../containers");
var _components = require("../components");
var _components2 = require("../../../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ResetPasswordView = props => {
  let image = null;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexFlow: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'container-fluid pb-5 justify-content-center position-relative'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-10 col-lg-8 col-xl-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex justify-content-center mb-5'
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Reset Password"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(_containers.ResetPassword, props, /*#__PURE__*/_react.default.createElement(_components.ResetPasswordForm, null))))))), /*#__PURE__*/_react.default.createElement(_components2.ImprintLink, null));
};
var _default = exports.default = ResetPasswordView;
module.exports = exports.default;